import {
  CREATE_MCU_PROJECT_PERIOD_CUT_OFF_FAIL,
  CREATE_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST,
  CREATE_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS,
  DELETE_MCU_PROJECT_PERIOD_CUT_OFF_FAIL,
  DELETE_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST,
  DELETE_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS,
  DETAIL_MCU_PROJECT_PERIOD_CUT_OFF_FAIL,
  DETAIL_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST,
  DETAIL_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS,
  LIST_MCU_PROJECT_PERIOD_CUT_OFF_FAIL,
  LIST_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST,
  LIST_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS,
  UPDATE_MCU_PROJECT_PERIOD_CUT_OFF_FAIL,
  UPDATE_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST,
  UPDATE_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS
} from '../../constants/mcu-project-period-cut-off'

const initialState = {
  loading: false,
  loadingDetail: false,
  loadingCreate: false,
  loadingDelete: false,
  selectedDeleteId: null,
  mcuProjectPeriodCutOffs: [],
  mcuProjectPeriodCutOff: {},
  error: null,
  pageable: {
    page: 1,
    size: 10,
    hits: 0
  }
}

const mcuProjectPeriodCutOffReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS:
      return {
        ...state,
        loading: false,
        mcuProjectPeriodCutOffs: action.payload,
        pageable: action.pageable || state.pageable
      }
    case LIST_MCU_PROJECT_PERIOD_CUT_OFF_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        mcuProjectPeriodCutOffs: []
      }
    case DETAIL_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST:
      return {
        ...state,
        loadingDetail: true,
        mcuProjectPeriodCutOff: {}
      }
    case DETAIL_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        mcuProjectPeriodCutOff: action.payload
      }
    case DETAIL_MCU_PROJECT_PERIOD_CUT_OFF_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
        mcuProjectPeriodCutOff: {}
      }
    case CREATE_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST:
    case UPDATE_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS:
    case UPDATE_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case CREATE_MCU_PROJECT_PERIOD_CUT_OFF_FAIL:
    case UPDATE_MCU_PROJECT_PERIOD_CUT_OFF_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DELETE_MCU_PROJECT_PERIOD_CUT_OFF_REQUEST:
      return {
        ...state,
        loadingDelete: true,
        selectedDeleteId: action?.meta?.cutOffId || null
      }
    case DELETE_MCU_PROJECT_PERIOD_CUT_OFF_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        selectedDeleteId: null
      }
    case DELETE_MCU_PROJECT_PERIOD_CUT_OFF_FAIL:
      return {
        ...state,
        loadingDelete: false,
        selectedDeleteId: null,
        error: action.payload
      }
    default:
      return state
  }
}

export default mcuProjectPeriodCutOffReducer
